<template>
  <div class="g-content g-detail-layout">
    <!-- 加载中 -->
    <Loading :show="false" v-if="false" />

    <!-- 网络错误 -->
    <div class="g-bg" v-else-if="networkError">
      <NetworkError style="position:relative;top: 100px;" />
    </div>

    <!-- 数据为空 -->
    <Empty v-else-if="!stationInfo" class="g-bg" />

    <div v-else class="g-detail-layout-main-wrapper">
      <!-- 站点标题 -->
      <div class="g-detail-layout-title" id="siteDetailTitle">
        <div class="g-detail-layout-title-content">
          <div class="g-detail-layout-title-left">
            {{ stationInfo ? stationInfo.name : '' }}
          </div>
          <div class="g-detail-layout-title-right">
            <!-- 编辑 -->
            <router-link
              :to="{
                name: 'SiteUpdate',
                params: { id: stationInfo.stationId },
              }"
              class="g-btn-link-icon"
              v-if="AUTH_SITE_EDIT"
            >
              <a-button type="primary">
                <Icon type="edit" />
              </a-button>
            </router-link>

            <!-- 删除 -->
            <a-button type="red" @click="deleteSite" v-if="AUTH_SITE_DELETE" class="g-btn-icon">
              <Icon type="delete" />
            </a-button>
          </div>
        </div>
      </div>

      <!-- 内容 -->
      <div class="g-detail-layout-main">
        <div class="g-detail-layout-main-side">
          <div id="siteDetailSideNav">
            <h3>{{ $t('site_title') }}</h3>
            <ul>
              <li
                v-for="item in sideList"
                :key="item.key"
                @click="sideClick(item.key)"
                :class="sideAcitve === item.key ? 'active' : ''"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="g-detail-layout-main-content layout-site-main-content">
          <!-- Overview -->
          <Overview :siteData="station" :stationId="stationId" v-if="sideAcitve === '1'" />
          <!-- Device -->
          <Device
            :siteData="station"
            :stationId="stationId"
            v-if="sideAcitve === '2' && AUTH_SITE_DETAIL_TAB_DEVICE"
          />
          <!-- 故障 -->
          <Fault
            :siteData="station"
            :stationId="stationId"
            v-if="sideAcitve === '3' && AUTH_SITE_DETAIL_TAB_FAULT"
          />
          <!-- 事件 -->
          <Event
            :siteData="station"
            :stationId="stationId"
            v-if="sideAcitve === '4' && AUTH_SITE_DETAIL_TAB_EVENT"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/site';
import Config from '@/config';
import areaMixin from '@/mixins/area';
import Overview from './components/Overview.vue';
import Device from './components/Device.vue';
import Fault from './components/Fault.vue';
import Event from './components/Event.vue';
import { deleteConfirm } from '@/libs/ant.design.fn';
import siteAuth from '@/views/site/mixins/siteAuth';

export default {
  mixins: [areaMixin, siteAuth],
  components: { Overview, Device, Fault, Event },
  data() {
    return {
      Config,

      loading: true,
      station: null,
      stationId: null,
      stationInfo: null,
      stationEvent: null,
      customerInfo: null,

      filters: this.$options.filters,
      eventColumns: [
        {
          title: this.$t('site_table_user'),
          align: 'left',
          dataIndex: 'executeUserName',
          width: 200,
          scopedSlots: { customRender: 'executeUserName' },
        },

        {
          title: this.$t('site_table_operation'),
          align: 'left',
          dataIndex: 'updateType',
          scopedSlots: { customRender: 'Operation' },
          width: 200,
        },
        {
          title: this.$t('site_table_time'),
          align: 'left',
          dataIndex: 'executeTime',
          scopedSlots: { customRender: 'time' },
        },
      ],

      networkError: false,

      // side list
      sideAcitve: '1',
      sideList: [
        {
          name: this.$t('site_overview'),
          key: '1',
        },
      ],

      sideNav: null,
      siteTitle: null,
    };
  },
  created() {
    if (this.$route && this.$route.params) {
      this.stationId = this.$route.params.id;
    }

    // tabs根据权限初始化
    if (this.AUTH_SITE_DETAIL_TAB_DEVICE) {
      // 设备权限
      this.sideList.push({
        name: this.$t('site_device'),
        key: '2',
      });
    }

    // 故障权限
    if (this.AUTH_SITE_DETAIL_TAB_FAULT) {
      this.sideList.push({
        name: this.$t('site_device_alarming'),
        key: '3',
      });
    }

    // 事件权限
    if (this.AUTH_SITE_DETAIL_TAB_EVENT) {
      this.sideList.push({
        name: this.$t('site_event'),
        key: '4',
      });
    }

    this.getData();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.fixedSideNav);
  },
  methods: {
    // fixed side nav
    fixedSideNav() {
      // 监听滚动，当#siteDetailSideNav不在可视区域时，固定在顶部
      if (!this.sideNav) {
        this.sideNav = document.getElementById('siteDetailSideNav');
      }
      if (!this.siteTitle) {
        this.siteTitle = document.getElementById('siteDetailTitle');
      }
      if (this.siteTitle && this.sideNav) {
        const layoutHistoryNavTop = this.siteTitle.getBoundingClientRect().height;
        if (window.scrollY > layoutHistoryNavTop) {
          this.sideNav.className = 'site-nav-fixed';
        } else {
          this.sideNav.className = 'site-nav-unfixed';
        }
      }
    },

    // side click
    sideClick(key) {
      this.sideAcitve = key;
    },

    // 获取表单数据
    getData() {
      const _list = [this.getDetail(), this.getAreaList()];
      Promise.all(_list).finally(() => {
        // 更新area/region

        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
        this.loading = false;

        // 监听滚动，当#siteDetailSideNav不在可视区域时，固定在顶部
        window.addEventListener('scroll', this.fixedSideNav);
      });
    },

    // 获取站点详情
    getDetail() {
      const params = {
        stationId: this.stationId,
      };
      this.loading = true;
      this.networkError = false;
      return API.SiteDetail(params)
        .then(res => {
          if (res && res.code === 0 && res.data) {
            this.station = res.data;
            // 站点详情
            this.stationInfo = res.data.info;
            // 站点事件
            this.stationEvent = res.data.events;
            // 站点所属客户
            this.customerInfo = res.data.customerInfo;

            // 记录当前站点路由
            this.$store.commit('setHistoryRouteList', {
              ...this.$route,
              title: this.stationInfo.name,
              type: 'site',
            });
          }
        })
        .catch(err => {
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.loading = false;
        });
    },

    // 删除站点确认框
    deleteSite() {
      const h = this.$createElement;
      deleteConfirm.call(this, {
        title: this.$t('site_confirm_delete_title'),
        content: h('div', {}, [h('p', this.$t('site_confirm_delete_description'))]),
        onOk: () => {
          this.deleteSiteHandler();
        },
      });
    },

    // 删除站点
    deleteSiteHandler() {
      this.deleteLoading = true;
      this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
      API.SiteDelete({ stationId: this.stationInfo.stationId })
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('com_msg_delete_success'));

            // 删除后回到列表
            this.$router.replace({
              name: 'SiteList',
            });
          }
        })
        .finally(() => {
          this.$store.commit('setFreeze', false);
        });
    },

    // 禁用站点->没用？没找到引用处
    disabledSite() {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('site_confirm_diabled_title'),
        content: h('div', {}, [
          h('p', this.$t('site_confirm_content', { name: this.stationInfo.name })),
        ]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_disable'));
          API.SiteDisable({ stationId: this.stationInfo.stationId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_disabled_success'));

                // 重新获取详情
                this.getDetail();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 启用站点->没用？没找到引用处
    enableSite() {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('site_confirm_enabled_title'),
        content: h('div', {}, [
          h('p', this.$t('site_confirm_content', { name: this.stationInfo.name })),
        ]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_enable'));
          API.SiteEnable({ stationId: this.stationInfo.stationId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_form_enabled_success'));

                // 重新获取详情
                this.getDetail();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.g-detail-layout-main-content.layout-site-main-content {
  width: calc(100% - 303px);
  overflow-x: hidden;
}

.site-nav-fixed {
  position: fixed;
  top: @g-layout-header-height + @g-layout-right-history-height + @g-24px;
  width: 198px;
}

.site-nav-unfixed {
  position: static;
  width: auto;
}

// box
.site-item {
  border: #eee solid 1px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  .site-item-title {
    padding: 5px 20px;
    background: #f9f9f9;
    border-bottom: #eee solid 1px;
    font-weight: bold;
    font-size: 14px;
  }

  ::v-deep .site-item-content {
    display: flex;
    padding: 15px 20px;
    // more
    .site-event-more {
      padding: 10px;
      text-align: right;
    }

    .ant-table-wrapper {
      width: 100%;
      .ant-table {
        .ant-table-thead {
          tr {
            th {
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        .ant-table-content {
          overflow-x: auto;
          .ant-table-body {
            table tr {
              &:last-child td {
                // border-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
.site-info {
  display: flex;

  .site-img {
    max-width: 280px;
    max-height: 200px;
    img {
      width: 100%;
      max-height: 100%;
    }
  }

  .site-props {
    flex: 1;
    padding: 0 0 0 20px;
    position: relative;
    ul {
      margin: 0;
      padding: 0;
      li {
        font-size: 12px;
        padding: 5px 0;
        display: flex;
        label {
          color: #999;
          margin-right: 5px;
        }

        span {
          color: #000;
          display: flex;
          align-items: center;
          font-weight: 500;
          em {
            font-style: normal;
          }

          i {
            display: block;
            width: 8px;
            height: 8px;
            border-radius: 100%;
            white-space: nowrap;
            margin-right: 5px;
            font-style: normal;

            &.disabled {
              background: #999;
            }

            &.enabled {
              background: #09f175;
            }
          }
        }
      }
    }

    .site-action {
      position: absolute;
      right: 0;
      bottom: 0;
      button {
        margin-left: 10px;
      }
    }
  }
}

.site-device-status {
  width: 100%;
  margin: 10px 0 0 0;
  display: flex;
  li {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    padding-bottom: 20px;
    width: 135px;

    &:last-child {
      border-bottom: none;
      display: flex;
      flex: 1;
      align-items: flex-end;
      justify-content: center;
      button {
        margin-right: 15px;
      }
    }
    label {
      height: 100%;
      line-height: 100%;
      min-width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      padding: 0 20px;
    }
    span {
      height: 100%;
      font-size: 24px;
      display: flex;
      align-items: center;

      em {
        font-style: normal;
      }
    }
  }
}

.site-device {
  padding-top: 20px;
  display: flex;
  align-items: stretch;
  width: 100%;

  ::v-deep .site-box {
    background: #fff;
    flex: 1;
    border: #eee solid 1px;
    border-bottom: none;
    box-sizing: border-box;
    width: 100%;

    &.site-box-emtpy {
      border: #eee solid 1px;

      .site-box-title {
        margin-bottom: 1px;
      }
    }

    .site-box-title {
      height: 45px;
      line-height: 45px;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 500;
      background: #fff;
      border-bottom: #eee solid 1px;
      display: flex;
      justify-content: space-between;

      a {
        font-size: 12px;
      }
    }

    .ant-table .ant-table-content .ant-table-body table tr:nth-child(10) td {
      border-bottom: 0;
    }
  }
}

.site-other {
  margin: 20px;
  ul {
    li {
      padding: 10px 0;

      label {
        padding-right: 10px;
      }
    }
  }
}
</style>
